import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Peaks({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  const scale = depth / 50;
  const y = val => 200 - (120 - val) * scale;

  // Focal point position: 0=left, 50=center, 100=right
  const focalX = (position / 100) * 1200;

  // Peak positions and base heights (varied for jagged look)
  const peakX = [100, 250, 450, 600, 750, 950, 1100];
  const baseHeights = [55, 80, 40, 75, 45, 85, 60];

  // Apply envelope: peaks closer to focal get boosted (lower Y = taller)
  const points = peakX
    .map((x, i) => {
      const baseH = baseHeights[i] || 50;
      const dist = Math.abs(x - focalX);
      const proximity = 1 - Math.min(dist / 600, 1);
      const boost = proximity * 35;
      const h = Math.max(20, baseH - boost);
      return `${x},${y(h)}`;
    })
    .join(' ');

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 200'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <polygon points={ `0,200 ${points} 1200,200` } fill={ fill } mask={ mask } />
    </svg>
  );
}

Peaks.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
